<template>
  <vue-drr
    :parent="true"
    :rotatable="false"
    :w="w"
    :h="h"
    :x="x"
    :y="y"
    class="widget-container"
    ref="widget"
    @dragstop="dragStop"
    @resizestop="resizeStop"
    :style="{
      backgroundColor: backgroundColor,
      paddingLeft: `${paddingLeft}px`,
      paddingTop: `${paddingTop}px`,
      paddingRight: `${paddingRight}px`,
      paddingBottom: `${paddingBottom}px`,
      zIndex: zIndex,
    }"
  >
    <div
      class="widget animated bounceIn"
      :class="{
        'align-center': verticalAlign == 'center',
        'align-end': verticalAlign == 'bottom',
        'text-xs-center': horizontalAlign == 'center',
        'text-xs-right': horizontalAlign == 'right',
      }"
      :id="`widget${id}`"
      @click="setActiveWidget"
    >
      <div
        v-html="$sanitize(text)"
        style="width: 100%;"
      ></div>
    </div>
  </vue-drr>
</template>

<script>
import Vue from 'vue';
import sanitizeHTML from 'sanitize-html';
import VueDrr from 'vue-drr';
import WidgetMixin from './WidgetMixin';
import { mapWidgets } from './WidgetUtils';

Vue.prototype.$sanitize = sanitizeHTML;

export default {
  components: {
    'vue-drr': VueDrr,
  },
  mixins: [WidgetMixin],
  computed: {
    ...mapWidgets(
      [
        {
          path: '',
          key: 'name',
        },
        {
          path: '',
          key: 'icon',
        },
        {
          path: '',
          key: 'component',
        },
        {
          path: 'dataText',
          key: 'text',
        },
        {
          path: 'style',
          key: 'horizontalAlign',
        },
        {
          path: 'style',
          key: 'verticalAlign',
        },
        {
          path: 'style',
          key: 'paddingLeft',
        },
        {
          path: 'style',
          key: 'paddingTop',
        },
        {
          path: 'style',
          key: 'paddingRight',
        },
        {
          path: 'style',
          key: 'paddingBottom',
        },
        {
          path: 'style',
          key: 'backgroundColor',
        },
        {
          path: 'style',
          key: 'zIndex',
        },
        {
          path: 'style',
          key: 'w',
        },
        {
          path: 'style',
          key: 'h',
        },
        {
          path: 'style',
          key: 'x',
        },
        {
          path: 'style',
          key: 'y',
        },
      ],
    ),
  },
  created() {
    const payload = {
      data: [],
    };

    if (this.text == null) {
      payload.data.push({
        path: 'dataText',
        key: 'text',
        value: 'TEXT WIDGET',
      });
    }

    this.$store.dispatch(`widget${this.id}/UPDATE_WIDGET`, payload);
  },
};
</script>

<style scoped>

</style>
